import React from 'react';
import { ShareButtons, ShareCounts, generateShareIcon } from 'react-share';

const {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton
} = ShareButtons;

const {
  FacebookShareCount,
  LinkedinShareCount
} = ShareCounts;

const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const LinkedinIcon = generateShareIcon('linkedin');

const TITLES = {
  'gun-control': 'Wanna know what America thinks about Gun Control? #Elections16 #Trump #Hilary via @pollfish',
  'tax-policy': 'Wanna know what America thinks about Tax Policy? #Elections16 #Trump #Hilary via @pollfish',
  'presidential-candidates': 'Wanna know what America thinks about Presidential Candidates? #Elections16 #Trump #Hilary via @pollfish',
  'immigration-policy': 'Wanna know what America thinks about Immigration Policy? #Elections16 #Trump #Hilary via @pollfish'
}

const ShareSocialButtons = React.createClass({
  render() {
    const shareUrl = window.location.href;
    const selectedValue = window.location.pathname.split('/')[3];
    const title = TITLES[selectedValue];

    return (
      <div className="clearfix">
        <div className="some-network">
          <FacebookShareButton
            url={shareUrl}
            title={title}
            className="some-network__share-button">
            <FacebookIcon size={28} round />
          </FacebookShareButton>
          <FacebookShareCount
            url={shareUrl}
            className="some-network__share-count">
            {count => count}
          </FacebookShareCount>
        </div>

        <div className="some-network">
          <TwitterShareButton
            url={shareUrl}
            title={title}
            className="some-network__share-button">
            <TwitterIcon size={28} round />
          </TwitterShareButton>
        </div>

        <div className="some-network">
          <LinkedinShareButton
            url={shareUrl}
            title={title}
            windowWidth={750}
            windowHeight={600}
            className="some-network__share-button">
            <LinkedinIcon
              size={28}
              round />
          </LinkedinShareButton>

          <LinkedinShareCount
            url={shareUrl}
            className="some-network__share-count">
            {count => count}
          </LinkedinShareCount>
        </div>
      </div>
    )
  }
});

export default ShareSocialButtons;



/** WEBPACK FOOTER **
 ** ./src/components/share_social_buttons/index.js
 **/